import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { HorizontalAlignmentOptions } from '@df/ui/atomic/atomic-options';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { TButtonStyles, buttonStylesOptions } from '../../common/buttons/button-style/button-style.component';

export namespace NCmsButton {
    export const componentId = 'button';

    export interface IComponentData extends NICmsContentComponent.IData {
        buttonType: 'default' | 'inline' | 'text';
        buttonStyle: TButtonStyles;
        label: string;
        url?: string;
        align: 'left' | 'right' | 'center';
    }
}

@ICmsComponent<CmsButtonComponent>({
    id: NCmsButton.componentId,
    name: 'Button',
    tags: ['Content', 'Button'],
    isAdvanced: true,
    fields: [
        <NICmsContentField.IChoiceField>{
            key: 'buttonType',
            type: NICmsContentField.EFieldType.choice,
            title: 'Type',
            options: [
                { key: 'default', title: 'Default' },
                { key: 'inline', title: 'Inline Button' },
                { key: 'text', title: 'Text Button' }
            ],
            default: 'default',
            required: true
        },
        <NICmsContentField.IChoiceField>{
            key: 'buttonStyle',
            type: NICmsContentField.EFieldType.choice,
            title: 'Style',
            options: buttonStylesOptions,
            default: buttonStylesOptions[0].key ? buttonStylesOptions[0].key : undefined,
            canShow: (data: NCmsButton.IComponentData) => data.buttonType === 'default'
        },
        {
            key: 'label',
            type: NICmsContentField.EFieldType.text,
            title: 'Label',
            default: 'Button',
            required: true
        },
        {
            key: 'url',
            type: NICmsContentField.EFieldType.text,
            title: 'URL'
        },
        <NICmsContentField.IChoiceField>{
            key: 'align',
            type: NICmsContentField.EFieldType.choice,
            title: 'Alignment',
            options: HorizontalAlignmentOptions,
            default: 'left',
            required: true
        }
    ],
    priority: 10
})
@Component({
    selector: 'cms-button',
    templateUrl: './cms-button.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsButtonComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component?: NCmsButton.IComponentData;

    get align(): string {
        switch (this.component?.align) {
            case 'center':
                return 'flex-justify-center';
            case 'right':
                return 'flex-justify-end';
            default:
                return 'flex-justify-start';
        }
    }
}
